module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-from-bottom-7f6895c294fea113d7640d2091f192f1.svg";